<template>
  <div class="logging">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <LoggingTable />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import LoggingTable from '@/components/Logging/LoggingTable';

export default {
  name: 'Logging',
  components: {
    Breadcrumbs,
    LoggingTable,
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('logging') }];
    },
  },
};
</script>

<style lang="scss"></style>
